var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	9651: {
		fallback: () => (() => (__webpack_require__(8303))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.9.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	9948: {
		fallback: () => (() => (__webpack_require__(8303))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	7747: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	3490: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.8",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	3347: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.3.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	3336: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	8201: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.9.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	4670: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.11.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	4354: {
		fallback: () => (() => (__webpack_require__(2990))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [9651,9948,7747,3490,3347,3336,8201];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"151": [
		4670,
		4354
	],
	"792": [
		9651,
		9948,
		7747,
		3490,
		3347,
		3336,
		8201
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}